import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { ComingSoonComponent } from '@nucleus/ui-common';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    ComingSoonComponent,
    HomeRoutingModule
  ],
  bootstrap: [HomeComponent]
})
export class HomeModule { }
